import React from 'react';

import Button from 'koba/components/Button';
import Icon from 'koba/components/Icon';
import { TFunction } from 'next-i18next';
import { LoadingSkeleton } from '@thinkific/chalk';
import { Attachment } from 'schema/Post/types';
import styles from './AttachmentPreview.module.scss';

interface ImagePreviewProps {
  attachments: Attachment[];
  onRemove(index: number): void;
  openAltTextModal: (index: number) => void;
  t: TFunction; // Would be better to pass in the translated strings used here
}

const Image = ({ fileName, url, onRemove, openAltTextModal, t }) => {
  return (
    <div
      aria-live="polite"
      className={styles['file-input__image-preview']}
      data-qa="image-preview"
      id="image-preview"
      role="region"
      title={t('Image Preview')}
    >
      <img
        alt={`Preview of ${fileName}`}
        className={styles['file-input__image']}
        src={url}
      />
      <Button
        appearance="default"
        ariaLabel={t('Alternative text')}
        className={styles['alt-image-button']}
        data-qa="image-preview__add-alt-text-button"
        onClick={openAltTextModal}
      >
        {t('communities_components-imagePreview-plus-alt', '+ Alt')}
      </Button>
      <Button
        appearance="default"
        ariaLabel={t('Remove attachment')}
        className={styles['remove-image-button']}
        data-qa="image-preview__remove-button"
        onClick={onRemove}
      >
        <Icon name="trash-can" />
      </Button>
    </div>
  );
};

const ImagePreview = ({
  attachments,
  onRemove,
  openAltTextModal,
  t,
}: ImagePreviewProps) => {
  return (
    <div className={styles['file-input__image-container']}>
      {attachments.map((attachment: Attachment, index: number) => {
        const { fileName, url, isLoading } = attachment;
        return (
          <React.Fragment key={`${fileName}-${url}`}>
            {isLoading ? (
              <LoadingSkeleton sectionHeight={120} />
            ) : (
              <Image
                fileName={fileName}
                openAltTextModal={() => openAltTextModal(index)}
                t={t}
                url={url}
                onRemove={() => onRemove(index)}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default ImagePreview;
